import { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import taskService from '../../../services/TaskService';

export default function useTaskView(taskId, setRows) {
  useEffect(() => {
    if (!taskId) return;
    taskService
      .markTaskViewed(taskId)
      .then((response) => {
        const task = response?.data?.data;
        if (!task) return;
        window.dispatchEvent(new Event('taskViewed'));
        // Update only view columns so a delayed response cannot overwrite edits.
        setRows((rows) =>
          rows.map((row) =>
            String(row.id) === String(task._id)
              ? {
                  ...row,
                  taskViewedByAssignee: task.taskViewedByAssignee ? 'Viewed' : 'Not Viewed',
                  taskViewedBySupporter: task.taskViewedBySupporter ? 'Viewed' : 'Not Viewed'
                }
              : row
          )
        );
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || 'Could not record task view');
      });
  }, [taskId, setRows]);
}
